<script setup lang="ts">
defineOptions({
	name: 'UserCommitment',
})

const { t: $t, locale } = useI18n()
const { $tThird } = useNuxtApp()

const firstHtml = computed(() => {
	return $tThird(
		'{the_users} undertake to comply with these {terms}, as well as to comply with any special notices or instructions for use contained therein and to act at all times in accordance with the legislation in force, morality, good customs, and the requirements of good faith and established public order, being diligent and refraining from using the {platform} in any way that may hinder, damage, or deteriorate its normal functioning, the assets or rights of {company}, of other {users}, or, in general, of any third party.',
		{
			the_users: `<span class="font-semibold capitalize">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			users: `<span class="font-semibold">${$t('Users')}</span>`,
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const secondHtml = computed(() => {
	return $tThird(
		`In this regard, {users} acknowledge that they are accountable for their actions when accessing or using the {platform} and for any resulting outcomes. Specifically, and without this implying any restriction to the above, {users} undertake to:`,
		{
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
		},
	)
})

const undertakeFirst = computed(() => {
	return $tThird(
		'Provide truthful information about the data requested in any forms available on the {platform}. {users} will be fully responsible for any data or content that they transmit or communicate to {company}.',
		{
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			users:
				locale.value === 'fr'
					? `<span class="font-semibold">${$t('the User')}  </span>`
					: `<span class="font-semibold capitalize">${$t('Users')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const undertakeSecond = computed(() => {
	return $tThird(
		'Not to send, upload, distribute, or disseminate through the {platform} any program, data, virus, code, or any other physical or electronic device that is likely to cause damage to it, to any of the services, or to any of the equipment, systems, or networks of {company} or of any other user, or, in general, of any third party.',
		{
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const undertakeThird = computed(() => {
	return $tThird(
		'To the maximum extent permitted by applicable law, not to alter, copy, download, modify, decompile, disassemble, reverse engineer, license, lease, sell, or imitate the {platform}, its contents, or its underlying software.',
		{
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
		},
	)
})

const undertakeFourth = computed(() => {
	return $tThird(
		'Not to send, upload, distribute, or disseminate through the {platform} any content that infringes industrial and/or intellectual property rights or trade secrets of third parties, nor, in general, any content of which {users} do not hold, in accordance with Applicable legislation, the right to make it available to third parties.',
		{
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
		},
	)
})

const undertakeFifth = computed(() => {
	return $tThird(
		'Refrain from sending, uploading, distributing, or disseminating any content on the {platform} that includes hate-related or violent material, or any other content, products, or services that breach or promote actions in violation of applicable legislation or the rights of third parties.',
		{
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
		},
	)
})

const undertakeSixth = computed(() => {
	return $tThird(
		'Not to impersonate another individual and refrain from using, deploying, operating, or creating a computer program to mimic the actions of a User {bot}.',
		{
			bot: '(“<span class="font-semibold">Bot</span>”)',
		},
	)
})
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-ph:handshake"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('User Commitment') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p v-html="firstHtml"></p>
			<p v-html="secondHtml"></p>

			<ul class="list-disc pl-7 space-y-2.5">
				<li v-html="undertakeFirst"></li>
				<li v-html="undertakeSecond"></li>
				<li v-html="undertakeThird"></li>
				<li v-html="undertakeFourth"></li>
				<li>
					{{
						$tThird(
							'Not to send, upload, distribute, or disseminate any unlawful, defamatory, harassing, abusive, fraudulent, obscene, or otherwise objectionable content',
						)
					}}.
				</li>
				<li>{{ $tThird('Not to engage in, promote, or encourage illegal activity') }}.</li>
				<li v-html="undertakeFifth"></li>
				<li v-html="undertakeSixth"></li>
			</ul>
		</div>
	</section>
</template>
